import { StringUtils } from '../../../utils/string';
import { FilterOptionOption } from 'react-select/dist/declarations/src/filters';

type TOption = {
  value: string;
  label: string;
  extra: string;
};

export class SearchHelper {
  static getSearchText(text: string = '') {
    return '*' + StringUtils.toAlphaNumericSpaceOnly(text).toUpperCase().trim().replace(/ /g, '*') + '*';
  }
  static getSearchFilter(filter: string = '') {
    return '*' + StringUtils.toAlphaNumericSpaceOnly(filter).toUpperCase().replace(/ /g, '*');
  }
  static filterOption(option: FilterOptionOption<TOption>, inputValue: string) {
    if (!inputValue) return true;
    const search = SearchHelper.getSearchFilter(inputValue);
    return option.data.extra.indexOf(search) >= 0;
  }
}
